import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import WSButton from "../../../../Components/Button/WSButton";
import WSSelectField from "../../../../Components/Select/WSSelect";
import WSTextField, { CurrencyType, TextType } from "../../../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../../../Components/WSTextArea/WSTextArea";
import clientConfig from '../../../../Config/clientConfig.json';
import { AppState } from "../../../../StateManagement/types";
import WSHiddenField from "../../../../Components/HiddenField/WSHiddenField";
interface  AdvancePaymentProps {
    control?: Control<any>;
    errors?: FieldErrors;
    register: UseFormRegister<any>;
    id: any;
    reset: UseFormReset<any>;
    paymentId?: string;
    setValue: UseFormSetValue<any>;
    onCancel:()=>void
    data?:any
}

const PaymentDrawyer: React.FC<AdvancePaymentProps> = ({
  control, errors, register, id, reset,  setValue,data,onCancel,paymentId
}) => {

      useEffect(() => {
        return () => {
            reset();
        };
    }, []);
  useEffect(()=>{
    if(data){
      setValue('amountReceived',data?.amountReceived)
      setValue('paymentMethod',data?.paymentMethod)
      setValue('transactionReference',data?.transactionReference)
      setValue('notes',data?.notes)
      setValue('paymentId',data?.id)
    }
  },[data,setValue,paymentId])
  const reduxComponentData = useSelector(
    (state: AppState) => state.components["paymentSubmit"],
    shallowEqual 
  );

  // Local state to store Redux data
  const [componentData, setComponentData] = useState(reduxComponentData);

  // Update useState when Redux state changes
  useEffect(() => {
    if (reduxComponentData) {
      setComponentData(reduxComponentData);
    }
  }, [reduxComponentData]);
  return (
    <Grid >
      {<Grid  container spacing={2}  mt={2}>

            <Grid item xs={12}>
              <Typography sx={{fontSize:'.75rem'}} fontWeight={"bold"}>Payment Information</Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
                    <WSSelectField
                        label={"Payment Method"}
                        {...register("paymentMethod")}
                        id="paymentMethod"
                        name="paymentMethod"
                        options={clientConfig.paymentMethodConfig.staticOptionData}
                        control={control}
                        rules={{ required: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <WSTextField
                        label={"Amount"}
                        {...register("amountReceived")}
                        id="amountReceived"
                        name="amountReceived"
                        control={control}
                        rules={{ required: true }}
                        type={TextType.Currency}
                        currency={CurrencyType.Rupee}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <WSTextField
                        label={"Transaction Reference"}
                        {...register("transactionReference")}
                        id="transactionReference"
                        name="transactionReference"
                        control={control}
                        rules={{ required: true }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <WSTextAreaField
                        label="Add Note"
                        id="notes"
                        setValue={setValue}
                        control={control}
                        {...register("notes")}
                        rules={{ required: false }}
                        name="notes"
                        rows={2}
                    />
                      <WSHiddenField control={control} name="paymentId" defaultValue={paymentId} />
                </Grid>
            <Grid item xs={12} sm={12}>
                <Divider />
                </Grid>

            <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton  className="ws-theme-crm" variant="outlined" id='paymentSubmit' label={"Save"} type="submit" size="medium" loading={reduxComponentData?.data?.loading}  />
                    </Grid>
                    <Grid item sx={{ marginRight: 0 }}>
                        <WSButton  id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium"  variant="outlined"  className="ws-theme-crm" />
                    </Grid>
                </Grid>
          </Grid>
   }
    </Grid>
  );
};
export default PaymentDrawyer;
